import { z } from 'zod';

const publicEnvironmentSchema = z.object({
    NEXT_PUBLIC_BACKEND_URL_SE: z.string(),
    NEXT_PUBLIC_BACKEND_URL_NO: z.string(),
    NEXT_PUBLIC_BACKEND_URL_DK: z.string(),
    NEXT_PUBLIC_BACKEND_URL_FI: z.string(),
    NEXT_PUBLIC_URL_SE: z.string(),
    NEXT_PUBLIC_URL_NO: z.string(),
    NEXT_PUBLIC_URL_DK: z.string(),
    NEXT_PUBLIC_URL_FI: z.string(),
    NEXT_PUBLIC_URL_SEFI: z.string(),
    NEXT_PUBLIC_INTRANET_URL: z.string(),
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: z.string(),
    NEXT_PUBLIC_LOCAL_AUTOLOGIN_HASH: z.string(),
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: z.string(),
    NEXT_PUBLIC_META_PIXEL_ID: z.string(),
    NEXT_PUBLIC_GUEST_CHECKOUT_ENABLED: z.boolean(),
    NEXT_PUBLIC_OMNIBUS_ENABLED: z.boolean(),
});

export const PUBLIC_ENV = publicEnvironmentSchema.parse({
    NEXT_PUBLIC_INTRANET_URL: process.env.NEXT_PUBLIC_INTRANET_URL,
    NEXT_PUBLIC_URL_SE: process.env.NEXT_PUBLIC_URL_SE,
    NEXT_PUBLIC_URL_NO: process.env.NEXT_PUBLIC_URL_NO,
    NEXT_PUBLIC_URL_DK: process.env.NEXT_PUBLIC_URL_DK,
    NEXT_PUBLIC_URL_FI: process.env.NEXT_PUBLIC_URL_FI,
    NEXT_PUBLIC_URL_SEFI: process.env.NEXT_PUBLIC_URL_SEFI,
    NEXT_PUBLIC_BACKEND_URL_SE: process.env.NEXT_PUBLIC_BACKEND_URL_SE,
    NEXT_PUBLIC_BACKEND_URL_NO: process.env.NEXT_PUBLIC_BACKEND_URL_NO,
    NEXT_PUBLIC_BACKEND_URL_DK: process.env.NEXT_PUBLIC_BACKEND_URL_DK,
    NEXT_PUBLIC_BACKEND_URL_FI: process.env.NEXT_PUBLIC_BACKEND_URL_FI,
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    NEXT_PUBLIC_LOCAL_AUTOLOGIN_HASH: process.env.NEXT_PUBLIC_LOCAL_AUTOLOGIN_HASH,
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
    NEXT_PUBLIC_META_PIXEL_ID: process.env.NEXT_PUBLIC_META_PIXEL_ID,
    NEXT_PUBLIC_GUEST_CHECKOUT_ENABLED: process.env.NEXT_PUBLIC_GUEST_CHECKOUT_ENABLED === '1',
    NEXT_PUBLIC_OMNIBUS_ENABLED: process.env.NEXT_PUBLIC_OMNIBUS_ENABLED === '1',
}) as z.infer<
    typeof publicEnvironmentSchema
>;
